// Notifications API — обёртки над backend: инбокс сотрудника (колокольчик +
// вкладка «Задачи»), журнал аудита (вкладка «Системные»), лог записей на занятия
// (вкладка «Запись на занятия»). Контракт сверен с apps/api.
import { api } from '@/lib/api';

// --- Инбокс сотрудника (employee-notifications) ----------------------------

export interface EmployeeNotification {
  id: string;
  kind: string;
  payload: Record<string, unknown>;
  read_at: string | null;
  created_at: string;
}

export interface NotificationsSummary {
  unread: number;
}

function qs(params: Record<string, string | number | boolean | undefined>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '') sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : '';
}

export async function getNotificationsSummary(): Promise<NotificationsSummary> {
  return api.get<NotificationsSummary>('/employee-notifications/summary');
}

export async function listNotifications(params: {
  limit?: number;
  unread_only?: boolean;
  kind_prefix?: string;
}): Promise<{ data: EmployeeNotification[] }> {
  return api.get<{ data: EmployeeNotification[] }>(`/employee-notifications${qs(params)}`);
}

export async function markNotificationRead(id: string): Promise<{ updated: boolean }> {
  return api.post<{ updated: boolean }>(`/employee-notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<{ updated: number }> {
  return api.post<{ updated: number }>('/employee-notifications/read-all');
}

// --- Журнал аудита (вкладка «Системные») -----------------------------------

export interface AuditLogRow {
  id: string;
  at: string;
  employee_id: string | null;
  employee_name: string | null;
  action: string;
  entity_type: string;
  entity_id: string;
  before: unknown | null;
  after: unknown | null;
}

export async function listAuditLog(params: {
  from?: string;
  to?: string;
  employee_id?: string;
  entity_type?: string;
  q?: string;
  limit?: number;
}): Promise<{ data: AuditLogRow[] }> {
  return api.get<{ data: AuditLogRow[] }>(`/audit-log${qs(params)}`);
}

// --- Вкладка «Пользователи» (П8): лог создания/изменения клиентов ------------

export interface ClientAuditRow {
  id: string;
  at: string;
  client_id: string;
  client_name: string | null;
  client_phone: string | null;
  client_status: string | null;
  kind: string; // 'new' | 'update'
  source_label: string;
  changed_fields: string[];
}

export async function listClientAudit(params: {
  from?: string;
  to?: string;
  type?: 'new' | 'update';
  source?: 'employee' | 'system' | 'webhook';
  q?: string;
  limit?: number;
}): Promise<{ data: ClientAuditRow[] }> {
  return api.get<{ data: ClientAuditRow[] }>(`/audit-log/clients${qs(params)}`);
}

// --- Лог записей на занятия (вкладка «Запись на занятия») -------------------

export interface EnrollmentLogRow {
  id: string;
  created_at: string;
  branch_name: string;
  client_id: string;
  client_name: string | null;
  client_phone: string | null;
  occurrence_id: string;
  occurrence_kind: string;
  group_name: string;
  scheduled_at: string;
  source_label: string;
  /** attendance.status — подписи в общем словаре lib/attendance-status. */
  status: string;
  is_waitlist: boolean;
}

export async function listEnrollmentLog(params: {
  from?: string;
  to?: string;
  kind?: string;
  client_q?: string;
  limit?: number;
}): Promise<{ data: EnrollmentLogRow[] }> {
  return api.get<{ data: EnrollmentLogRow[] }>(`/attendance/enrollment-log${qs(params)}`);
}
